var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('formulate-input',{staticClass:"w-[200px] lg:w-[240px]",attrs:{"type":"dropdown","options":_vm.stichtingenDropdown,"value":_vm.defaultStichting,"name":"stichting","placeholder":"Kies je stichting"},on:{"input":_vm.switchStichting}})}
var staticRenderFns = []

export { render, staticRenderFns }